export const errorConstants = {
    SET_SUCCESS_MESSAGE: 'SET_SUCCESS_MESSAGE',
    SET_WARNING_MESSAGE: 'SET_WARNING_MESSAGE',
    SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
    CLEAR_ERROR_MESSAGE: 'CLEAR_ERROR_MESSAGE'
}